import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Slides from '@ifeng-fe/ui_pc_slides';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';

const Slider = ({ content }) => {
    const sliderTmpl = (item) => {
        return (
            <div className={styles.big_pic}>
                <a href={item.url} className={styles.pic_img} target="_blank" data-nomask>
                    <img
                        src={formatImageWebpAuto(item?.thumbnails?.image?.[0]?.url, 800, 450)}
                        className={styles.trans}
                    />
                </a>
                <div className={styles.text} />
                <p className={styles.title}>
                    <a href={item.url} target="_blank" data-innermask>
                        {item.title}
                    </a>
                </p>
            </div>
        );
    };

    const config = {
        dots: true,
        dotsAction: 'hover',
        autoplayInterval: 3000,
        dotStyle: styles.dot,
        dotCurrentStyle: styles.current,
        sliderTmpl,
    };

    return (
        <div className={styles.slider}>
            <Slides content={content.slice(0, 12)} config={config} />
        </div>
    );
};

Slider.propTypes = {
    content: PropTypes.array,
};

export default errorBoundary(Slider);
